import { render, staticRenderFns } from "./UpdatingDialog.vue?vue&type=template&id=161206cf&"
import script from "./UpdatingDialog.vue?vue&type=script&lang=ts&"
export * from "./UpdatingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports